<template>
  <div>
    <Popup
      :zIndex="99"
      :raduis="false"
      :title="$t('Gattaran_mgt_Filter_WuXS' /**筛选 */)"
      v-model="show"
      @cancel="close"
      @confirm="confirm"
      :ratio="90"
      @maskClick="maskClick"
      :cancel-txt="gettext('取消')"
      :confirmTxt="gettext('确定')"
    >
      <div class="filter-seletor_warp">
        <div v-for="(item, index) in classdata" :key="index">
          <class-view
            :title="item.label"
            :options="item.options"
            :paramKey="item.key"
            :columns="item.col"
            v-model="item.value"
            @change="selectorChange"
            v-if="!item.hide"
          />
        </div>

        <class-view
          :title="$t('FoodB_0905__kaPI' /** 诊断分数 */)"
          v-if="!loading"
        >
          <template slot="content">
            <div class="slider">
              <div class="current-score">
                <template
                  v-if="
                    !(
                      queryData.diagnosisScoreStart === 0 &&
                      queryData.diagnosisScoreEnd === 100
                    )
                  "
                  >{{ queryData.diagnosisScoreStart }}~{{
                    queryData.diagnosisScoreEnd
                  }}, {{ gettext('已签约') }}</template
                >
              </div>
              <div class="slider-content">
                <pb-slider
                  v-model="scores"
                  @change="scoreChange"
                  range
                  :max="100"
                  :marks="{
                    0: '0',
                    100: '100'
                  }"
                >
                </pb-slider>
              </div>
            </div>
          </template>
        </class-view>
      </div>

      <rich-loading :size="16" v-show="loading" />
    </Popup>
  </div>
</template>
<script>
import { Popup } from '@/formily/src'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import classView from '@/components-new/classView/index.vue'
import { BIZ_STATUS_OPTIONS } from '@/consts'
import { getBizoppFilter } from '../../service'
import { SIGN_PARTY_TYPE_LIST } from '@/config/sign/enums'
import PbSlider from '@/components-new/slider/src/main.vue'
import { cloneDeep } from 'lodash-es'
export default {
  name: 'filterSeletor',
  components: { Popup, classView, PbSlider },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      visible: true,
      loading: true,
      shopLayerLevelList: [], // 门店运营价值
      typeList: SIGN_PARTY_TYPE_LIST, // 商户类型
      classdata: [], // 所有筛选项数据
      potential: [], // 商机等记
      rPerformance: [], // 商户等记
      strategyTag: [], // 业务策略
      scores: [0, 100],
      currentData: {}
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal, oldVal) {}
    },
    queryData: {
      deep: true,
      immediate: true,
      handler(v) {
        this.getSignStatusData()
      }
    },
    currentTab() {
      this.getSignStatusData()
    }
  },
  computed: {
    ...mapState('bizoppV2', {
      queryData: (state) => state.commonFilter,
      currentTab: (state) => state.currentTab,
      allFilterParams: (state) => state.allFilterParams // 全部筛选项数据
    }),
    ...mapGetters(['statusOptions'])
  },
  created() {
    this.init()
  },

  methods: {
    ...mapActions('bizoppV2', ['getStrategyTag']),
    ...mapMutations('bizoppV2', [
      'updateCondition',
      'updateAllFilterParams',
      'updateStrategyTagFromWorkbench'
    ]),
    // 获取数据
    async init() {
      this.loading = true
      await this.fetchsShopLayerLevel()
      await this.getStrategyTagTree()
      await this.getSignStatusData()
      this.loading = false
    },
    getSignStatusData() {
      const filters = [
        {
          label: this.$t('FoodB_list_Name_of_dxYm' /** 销售姓名 */),
          key: 'notMyStore',
          col: 1,
          value: [false],
          options: [
            {
              label: this.$t('FoodB_030_SQUQ_YDRS' /** 商户等级 */),
              value: true
            }
          ],
          hide: this.currentTab !== 'areaStore'
        },
        {
          label: this.gettext('签约状态'),
          key: 'status',
          col: 2,
          options: this.getStatusLabelCount(),
          hide: false
        },
        {
          label: this.$t('Gattaran_V20__eJGq' /** 商机等级 */),
          key: 'potential',
          col: 3,
          options: (this.potential || []).map((item) => ({
            label: item.value,
            value: item.key
          })),
          hide: false
        },
        {
          label: this.$t('Gattaran_V20__THMR' /** 商户等级 */),
          key: 'rPerformance',
          col: 3,
          options: (this.rPerformance || []).map((item) => ({
            label: item.value,
            value: item.key
          })),
          hide: false
        },
        {
          label: this.$t('FoodB_Commision_Type_of_EIWZ' /** 商户类型 */),
          key: 'type',
          col: 3,
          options: (this.typeList || []).map((item) => ({
            label: item.label,
            value: item.value
          })),
          hide: this.currentTab === 'areaStore'
        },
        {
          label: this.gettext('经营状态'),
          key: 'bizStatus',
          col: 1,
          options: BIZ_STATUS_OPTIONS,
          hide: false
        }
      ]
      const filterMerge = filters.concat(this.strategyTag)
      this.classdata = filterMerge.map((item) => ({
        ...item,
        value: this.queryData[item.key]
      }))
    },
    // 获取数据带签约状态带number
    getStatusLabelCount() {
      const arr =
        this.statusOptions &&
        this.statusOptions.map((item) => {
          return {
            label: `${item.label}(${item.count})`,
            value: item.value
          }
        })
      return arr
    },
    // 获取商机、商户运营价值的数据
    fetchsShopLayerLevel() {
      getBizoppFilter().then(({ potential = [], rPerformance = [] }) => {
        this.potential = potential
        this.rPerformance = rPerformance
      })
    },
    // 获取业务策略下拉
    async getStrategyTagTree() {
      try {
        const res = await this.getStrategyTag()
        let filterData = []
        if (res !== undefined && res.length) {
          res.map((item) => {
            filterData.push({
              label: item.categoryName,
              key: 'arrStrategyTag',
              col: 2,
              options: (item.children || []).map((item) => ({
                label: item.tagName,
                value: item.tagId
              }))
            })
          })

          this.strategyTag = filterData
        }
      } catch (e) {
        console.error(e)
      }
    },
    scoreChange(value = []) {
      const [diagnosisScoreStart, diagnosisScoreEnd] = value || []
      this.currentData.diagnosisScoreStart = diagnosisScoreStart
      this.currentData.diagnosisScoreEnd = diagnosisScoreEnd
      const selectFilter = {
        ...this.currentData,
        diagnosisScoreStart,
        diagnosisScoreEnd,
        diagnosisScoreFlag:
          diagnosisScoreStart === 0 && diagnosisScoreEnd === 100 ? 0 : 1
      }
      this.updateCondition(cloneDeep(selectFilter))
      // this.updateAllFilterParams({
      //   ...this.allFilterParams,
      //   ...selectFilter
      // })
      this.$emit('change')
    },
    //
    close() {
      const resetFilter = {
        status: [],
        rank: [],
        // type: 0, // 门店类型
        shopLayerLevel: [], // 商户运营价值
        qualityTags: [],
        bizStatus: [],
        potential: [],
        rPerformance: [],
        // 排序
        // sortType: 0,
        // 诊断分数
        diagnosisScoreStart: 0,
        diagnosisScoreEnd: 100,
        arrStrategyTag: [],
        notMyStore: ''
      }
      this.updateCondition(cloneDeep(resetFilter))
      this.classdata = this.classdata.map((item) => ({
        ...item,
        value: resetFilter[item.key]
      }))
      this.$emit('cancel', 3)
    },
    confirm(close) {
      this.updateStrategyTagFromWorkbench(false)
      this.updateCondition(cloneDeep(this.currentData))
      this.updateAllFilterParams({
        ...this.allFilterParams,
        ...this.currentData
      })
      this.$emit('cancel')
    },
    maskClick() {
      this.$emit('cancel', 2)
    },
    selectorChange({ key, value }) {
      this.currentData[key] = value
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-seletor_warp {
  padding: 39px;
  .slider {
    margin-bottom: 100px;
    .current-score {
      font-family: DiDiSans-Pro-Bold;
      font-size: 28px;
      color: #ff7a45;
      height: 44px;
      line-height: 44px;
      font-weight: normal;
      margin-top: 16px;
      margin-bottom: 60px;
    }
    .slider-title {
      font-family: DiDiSans-Pro-Medium;
      font-size: 36px;
      color: #282b33;
      line-height: 44px;
      font-weight: 500;
    }
    .slider-content {
      padding: 0 16px;
    }
  }
}
</style>
